import { render, staticRenderFns } from "./SellerOffersInsights.vue?vue&type=template&id=f816a8a8&scoped=true"
import script from "./SellerOffersInsights.vue?vue&type=script&lang=js"
export * from "./SellerOffersInsights.vue?vue&type=script&lang=js"
import style0 from "./SellerOffersInsights.vue?vue&type=style&index=0&id=f816a8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f816a8a8",
  null
  
)

export default component.exports